import React from 'react';
import {
	ChartComponent, SeriesCollectionDirective, SeriesDirective,
	ColumnSeries, Category, Tooltip, Legend, DataLabel, Highlight,
	Inject
} from '@syncfusion/ej2-react-charts';

const formatEuro = (value) =>
	new Intl.NumberFormat('fr-FR', {
		style: 'currency',
		currency: 'EUR',
		maximumFractionDigits: 0,
	}).format(value);

const DoubleColumnChartDecla = ({ data, title = '', id = 'double-column-chart-decla' }) => {

	const projects = [...new Set(data.map(d => d.x))];

	const declarations = projects.map(project => {
		const item = data.find(d => d.x === project && d.category === 'Déclarations');
		return {
			x: project.length > 15 ? project.substring(0, 15) + '...' : project,
			y: item ? Math.round(item.y) : 0,
			libelle: item?.libelle || project
		};
	});

	const pathologies = projects.map(project => {
		const item = data.find(d => d.x === project && d.category === 'Pathologies');
		return {
			x: project.length > 15 ? project.substring(0, 15) + '...' : project,
			y: item ? Math.round(item.y) : 0,
			libelle: item?.libelle || project
		};
	});

	const tooltipRender = (args) => {
		const libelle = args.point.tooltip || 'Non renseigné';
		const maxLength = 60;

		const shortenedLibelle = libelle.length > maxLength
			? libelle.substring(0, maxLength) + '...'
			: libelle;

		args.text = `${shortenedLibelle} : <b>${formatEuro(args.point.y)}</b>`;
	};

	return (
		<div className="w-full">
			{title && <h2 className="mb-4 font-semibold text-lg text-center">{title}</h2>}
			<ChartComponent
				id={id}
				primaryXAxis={{
					valueType: 'Category',
					labelIntersectAction: 'Trim',
					labelRotation: -45,
					majorGridLines: { width: 0 },
					labelStyle: { size: '11px' }
				}}
				primaryYAxis={{
					labelFormat: '{value}',
					majorTickLines: { width: 0 },
					lineStyle: { width: 0 },
					labelStyle: { size: '11px' },
					titleStyle: { size: '13px' },
					labelFormat: '{value} €'
				}}
				chartArea={{ border: { width: 0 } }}
				legendSettings={{
					padding: 5,
					shapeHeight: 8,
					shapeWidth: 8,
					enableHighlight: true
				}}
				axisLabelRender={(args) => {
					const val = parseFloat(args.text.replace(/\s/g, '').replace(',', '.'));
					if (!isNaN(val)) {
						args.text = `${val.toLocaleString('fr-FR').replace(/\s/g, '\u202F')} €`;
					}
				}}

				tooltip={{ enable: true }}
				tooltipRender={tooltipRender}
				height="450px"
				width="100%"
			>
				<Inject services={[ColumnSeries, Legend, Tooltip, Category, DataLabel, Highlight]} />
				<SeriesCollectionDirective>
					<SeriesDirective
						dataSource={declarations}
						xName="x"
						yName="y"
						name="Montant Déclarations"
						type="Column"
						fill="#2485FA"
						tooltipMappingName="libelle"
						cornerRadius={{ topLeft: 4, topRight: 4 }}
						marker={{ dataLabel: { visible: false } }}
					/>
					<SeriesDirective
						dataSource={pathologies}
						xName="x"
						yName="y"
						name="Montant Pathologies"
						type="Column"
						fill="#FEC200"
						tooltipMappingName="libelle"
						cornerRadius={{ topLeft: 4, topRight: 4 }}
						marker={{ dataLabel: { visible: false } }}
					/>
				</SeriesCollectionDirective>
			</ChartComponent>
		</div>
	);
};

export default DoubleColumnChartDecla;
